// Facebook login with JavaScript SDK
function loginAsync() {
  return new Promise((resolve, reject) => {
    window.FB.login((response) => {
      if (response.error) {
        reject(response);
      } else {
        resolve(response);
      }
    }, { scope: 'email,user_birthday', auth_type: 'rerequest' });
  });
}

function meAsync() {
  return new Promise((resolve, reject) => {
    window.FB.api('/me', {
      locale: 'fr_FR',
      fields: 'id,first_name,last_name,email,link,gender,locale,picture,birthday',
    }, (response) => {
      if (response.error) {
        reject(response);
      } else {
        resolve(response);
      }
    });
  });
}

function getLoginStatusAsync() {
  return new Promise((resolve, reject) => {
    window.FB.getLoginStatus((response) => {
      if (response.error) {
        reject(response);
      } else {
        resolve(response);
      }
    });
  });
}

export default {
  login: loginAsync,
  me: meAsync,
  getLoginStatus: getLoginStatusAsync,
};
